module.exports = __webpack_public_path__ + "media/images/countryrect/py-e77b257322716ab0bbd03a4197ac7d51.svg";